export const socketGamePath = 'game';
export const gameName = 'golden-reels-40';
